// Client-side factory for the admin-web RealtimeSubscriber. Constructed once and
// passed into the layout's <RealtimeProvider>.
//
// BL-1586 AC 3 — the memoization and the gateway wiring live in
// `createRealtimeSubscriberSingleton` in `@auctogon/core/realtime`; this file keeps
// only the literal `process.env.NEXT_PUBLIC_*` read, which cannot move into a
// shared package.
//
// No presence-token minter (BL-1833 PR 3a). admin-web joins no presence room —
// BL-1556 removed its only presence subscription, and the clerk rail reads the
// roster server-side — so its mint route (`/api/realtime/presence/token`) was
// deleted rather than left reachable (ADR 044 — Must Consolidate). Bidder-web
// keeps its own minter and route.

'use client';

// Mirror of the publisher's `server-only` guard — fails the build at import
// time if this module ever lands in a server bundle: the transport it returns
// opens a browser WebSocket.
import 'client-only';

import { createRealtimeSubscriberSingleton } from '@auctogon/core/realtime/create-subscriber';
import type { RealtimeSubscriber } from '@auctogon/core/realtime';

/**
 * Returns the per-tab RealtimeSubscriber for snapshot + ledger topics.
 *
 * The env read stays HERE rather than inside the shared package because
 * `NEXT_PUBLIC_*` is inlined by Next at the literal `process.env.X` site.
 *
 * @returns The memoized subscriber for this tab.
 */
export function getRealtimeSubscriber(): RealtimeSubscriber {
    return createRealtimeSubscriberSingleton({
        gatewayUrl: process.env.NEXT_PUBLIC_REALTIME_GATEWAY_URL,
    });
}
